import axios from 'axios';
import React, { Component } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import HistoryRoundedIcon from '@material-ui/icons/HistoryRounded';
import ReplayRoundedIcon from '@material-ui/icons/ReplayRounded';
import PlaylistAddRoundedIcon from '@material-ui/icons/PlaylistAddRounded';
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import PersonOutlineRoundedIcon from '@material-ui/icons/PersonOutlineRounded';
import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined';
import HomeWorkOutlinedIcon from '@material-ui/icons/HomeWorkOutlined';
import ViewQuiltOutlinedIcon from '@material-ui/icons/ViewQuiltOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import PhotoLibraryOutlinedIcon from '@material-ui/icons/PhotoLibraryOutlined';
import PlaylistAddCheckOutlinedIcon from '@material-ui/icons/PlaylistAddCheckOutlined';
import MoveToInboxOutlinedIcon from '@material-ui/icons/MoveToInboxOutlined';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined';
import moment from 'moment';
import Loading from '../../components/loading/loading';
import Navbar from '../../components/navBar/navBar';

import {
  apiList,
  encrypt,
  dencrypt,
  variables,
  verifyLogin,
  shortDate,
  addCommas,
  shortData,
  summation,
} from '../../helpers';
import DisbursementTable from './DisbursementTable';
import TaskTable from './TaskTable';
import PropertyComponentDetailsTable from './PropertyComponentDetailsTable';
import ConstructionPlanTable from './ConstructionPlanTable';
import DisbursalTable from './DisbursalTable';
import CustomAlert from '../../components/CustomAlert/CustomAlert';

import CustomModal from '../../components/CustomModal/CustomModal';
import SidePanel from '../../components/SidePanel/SidePanel';
import OldPlansPanel from './OldPlansPanel';
import FormLoanProperty from './FormLoanProperty';
import FormPropertyComponent from './FormPropertyComponent';
import FormCustomerDetails from './FormCustomerDetails';
import FormCreateConstructionPlan from './FormCreateConstructionPlan';
import FormLoanTask from './FormLoanTask';
import FormLoanDisbursement from './FormLoanDisbursement';
import UncategorizedMediaTable from './UncategorizedMediaTable';
import ReportFormatPanel from '../../components/ReportFormatPanel/ReportFormatPanel';
import {
  DetailPageSkeleton, DetailSection, Field, FieldGrid, SectionButton, SectionFooter,
} from '../../components/DetailSection/DetailSection';
import { groupDataByactivityTypeAndName } from '../../helpers/utils';
import PageContainer from '../../components/PageContainer/PageContainer';

const successTimeOut = variables.SUCCESS_TIMEOUT;
const errorTimeOut = variables.SUCCUSS_TIMEOUT;
// "Construction Progress (Photos & Videos)" (uncategorized media) was never
// fully implemented and is always empty, so it is hidden. To be removed.
const SHOW_UNCATEGORIZED_MEDIA = false;
// Property components are being decommissioned (see Backlog): the
// "Property Components: Click here to add" field is hidden. Loans that
// already have components still show their Property Component Details.
const SHOW_ADD_PROPERTY_COMPONENTS = false;

class LoanDetails extends Component {
  constructor() {
    super();
    this.state = {
      result: false,
      sectionOne: true,
      sectionTwo: true,
      sectionThree: true,
      sectionFour: true,
      sectionFive: true,
      sectionSix: true,
      sectionSeven: true,
      sectionEight: true,
      sectionNine: true,
      constructionPlanVersion: -1,
      isCurrentPlan: true,
      data: {},
      floorNameConfig: [],
      componentConfig: [],
      constructionPlan: [],

      dataLoaded: false,
      constructionPlanLoaded: false,
      // First load: skeleton until the loan (and its plan) are in.
      initialLoading: true,

      propertyDescription: '',
      addressLine1: '',
      addressLine2: '',
      lat: '',
      lng: '',
      planID: -1,
      floorNumber: '',
      componentConfigId: '',
      componentDimen: '',
      width: '',
      length: '',

      formOpen: false,
      newForm: true,

      formCustomerIDsOpen: false,
      formAddPlanIDOpen: false,
      reportFormatListModal: false,
      oldPlansOpen: false,

      formOpenpc: false,
      newFormpc: true,
      showAlert: false,

      loanTasks: [],
      loanTaskDetails: {},
      showContructionPlanModuleAlert: false,
      disbursementAmount: '',
      disbursementPerc: '',
      totalPercentage: 0,
      disbursementDate: '',
      disbursementId: null,
      disbursementModalOpen: false,

      loanPermission: {},
      customerPermission: {},
      disbursementPermission: {},
      propDetailsPermission: {},
      propComponentsPermission: {},
      constructionPlanPermission: {},
      loanTaskPermission: {},
      disRequestPermission: {},
      geoTaggPermission: {},
      mediaSubmissionNoPlanPermission: {},
      mediaSubmissionPeriodPermission: {},
      showPropertyComponents: false,
      constructionModuleplanName: '',
      reportFormats: [],
    };
    this.disbumentTableRef = React.createRef();
    this.taskConfigTableRef = React.createRef();
  }

  componentDidMount() {
    const { session, roleMapping, user } = verifyLogin();
    if (user.userRoleId === 1 || user.userRoleId === 2) {
      this.setState({
        loanPermission: {
          view: true, add: true, edit: true, delete: true,
        },
        customerPermission: {
          view: true, add: true, edit: true, delete: true,
        },
        disbursementPermission: {
          view: true, add: true, edit: true, delete: true,
        },
        propDetailsPermission: {
          view: true, add: true, edit: true, delete: true,
        },
        propComponentsPermission: {
          view: true, add: true, edit: true, delete: true,
        },
        constructionPlanPermission: {
          view: true, add: true, edit: true, delete: true,
        },
        loanTaskPermission: {
          view: true, add: true, edit: true, delete: true,
        },
        disRequestPermission: {
          view: true, add: true, edit: true, delete: true,
        },
        permission: {
          view: true, add: true, edit: true, delete: true,
        },
        geoTaggPermission: {
          view: true, add: true, edit: true, delete: true,
        },
        mediaSubmissionNoPlanPermission: {
          view: true, add: true, edit: true, delete: true,
        },
        mediaSubmissionPeriodPermission: {
          view: true, add: true, edit: true, delete: true,
        },
      });
    } else {
      const loanPermission = roleMapping.find((obj) => obj.PermissionConfig?.name === 'Loan');
      const customerPermission = roleMapping.find((obj) => obj.PermissionConfig?.name === 'Customer');
      const disbursementPermission = roleMapping.find((obj) => obj.PermissionConfig?.name === 'Disbursement');
      const propDetailsPermission = roleMapping.find((obj) => obj.PermissionConfig?.name === 'Property Details');
      const propComponentsPermission = roleMapping.find((obj) => obj.PermissionConfig?.name === 'Property Component');
      const constructionPlanPermission = roleMapping.find((obj) => obj.PermissionConfig?.name === 'Construction Plan');
      const loanTaskPermission = roleMapping.find((obj) => obj.PermissionConfig?.name === 'Loan Tasks');
      const disRequestPermission = roleMapping.find((obj) => obj.PermissionConfig?.name === 'Disbursal Requests');
      const geoTaggPermission = roleMapping.find((obj) => obj.PermissionConfig?.name === 'Geo Tag E-D');
      const mediaSubmissionNoPlanPermission = roleMapping.find((obj) => obj.PermissionConfig?.name === 'Allow Direct Media');
      const mediaSubmissionPeriodPermission = roleMapping.find((obj) => obj.PermissionConfig?.name === 'Reset Cooling Period');
      this.setState({
        loanPermission: loanPermission || {},
        customerPermission: customerPermission || {},
        disbursementPermission: disbursementPermission || {},
        propDetailsPermission: propDetailsPermission || {},
        propComponentsPermission: propComponentsPermission || {},
        constructionPlanPermission: constructionPlanPermission || {},
        loanTaskPermission: loanTaskPermission || {},
        disRequestPermission: disRequestPermission || {},
        geoTaggPermission: geoTaggPermission || {},
        mediaSubmissionNoPlanPermission: mediaSubmissionNoPlanPermission || {},
        mediaSubmissionPeriodPermission: mediaSubmissionPeriodPermission || {},
      });
    }
    const config = { headers: { session } };
    this.getLoanDetails();
    this.handleFetchFloorNameConfig(config);
    this.handleFetchComponentConfig(config);
  }

  // Loads quietly (no overlay): on first load the skeleton covers it, on a
  // refresh the page stays as is until the new plan arrives.
  handleFetchExistingPlan(loanId, version) {
    const { session } = verifyLogin();
    const config = { headers: { session, permissionConfig: 'Construction Plan', feature: 'view' } };
    axios.get(`${apiList.VIEW_CONSTRUCTION_PLAN_API}/${loanId}/${version}`, config)
      .then((response) => {
        if (response?.data?.result?.constructionPlan) {
          console.log(response.data.result);
          const { constructionPlanModuleName, constructionPlan } = response.data.result;
          console.log(constructionPlan, constructionPlanModuleName);
          this.setState({
            constructionPlan: [...constructionPlan],
            constructionModuleplanName: constructionPlanModuleName,
            constructionPlanLoaded: true,
            isCurrentPlan: !version,
          });
          if (!version) {
            this.setState({
              constructionPlanVersion: constructionPlan[0].version,
            });
          }
        }
        this.setState({ initialLoading: false });
      })
      .catch((e) => {
        console.log(e);
        this.setState({ initialLoading: false });
      });
  }

  // Form options, fetched in the background (no overlay).
  handleFetchFloorNameConfig(config) {
    axios.get(`${apiList.VIEW_USERS_FLOOR_CONFIG_API}`, config)
      .then((response) => {
        this.setState({ floorNameConfig: [...response.data.data.paginate] });
      })
      .catch((error) => {
        toast.error(`${error?.response?.data?.error || error?.response?.data?.message || 'Error Occuered'}`);
      });
  }

  // Form options, fetched in the background (no overlay).
  handleFetchComponentConfig(config) {
    axios.get(`${apiList.VIEW_USERS_COMPONENT_CONFIG_API}`, config)
      .then((response) => {
        this.setState({ componentConfig: [...response.data.data.paginate] });
      })
      .catch((error) => {
        toast.error(`${error?.response?.data?.error || error?.response?.data?.message || 'Error Occuered'}`);
      });
  }

  handleCollapse(key, id) {
    key.preventDefault();
    this.setState((prevState) => ({ [id]: !prevState[id] }));
  }

  handleShowAddForm(key) {
    key.preventDefault();
    const { data } = this.state;

    if (data.LoanProperty.id.length < 1) {
      toast.error('Loan Property id is required');
      return;
    }

    this.setState({
      formOpenpc: true,
      newFormpc: true,
      componentConfigId: '',
      componentDimen: '',
      floorNumber: '',
      width: '',
      length: '',
    });
  }

  handleCreateConstructionPlan(key, propertyId, planID) {
    key.preventDefault();
    this.setState({ result: true });
    const { user } = verifyLogin();

    const url = `${apiList.CREATE_CONSTRUCTION_PLAN_API}/${propertyId}/${planID}/${user.id}`;

    axios.get(url)
      .then((response) => {
        if (response?.data?.result?.constructionPlan) {
          const { constructionPlanModuleName, constructionPlan } = response.data.result;
          this.setState({
            constructionPlan: [...constructionPlan],
            constructionModuleplanName: constructionPlanModuleName,
            constructionPlanLoaded: true,
            constructionPlanVersion: constructionPlan[0].version,
            isCurrentPlan: true,
          });
        }
        toast.success(`${JSON.stringify(response.data.message)}`);
        this.setState({ result: false, formAddPlanIDOpen: false });
      })
      .catch((error) => {
        toast.error(`${JSON.stringify(error.response)}`);
        this.setState({ result: false });
      });
  }

  handleCreateConstructionPlanButton(key) {
    key.preventDefault();
    const { data, planID } = this.state;

    if (!data || !data.LoanProperty
      || (data.LoanProperty.id.length < 1 && data.subscriberId.length < 1)) {
      toast.error('There is not data to generate plan.');
      return;
    }
    if (planID === -1) {
      toast.error('Please select Construction Plan Config.');
      return;
    }
    this.handleCreateConstructionPlan(key, data.LoanProperty.id, planID);
  }

  handleViewConstructionDetails(key, data) {
    key.preventDefault();
    const detailId = encrypt(JSON.stringify(data));
    const redirectUrl = `/view-construction-details/${detailId}`;
    window.open(redirectUrl, '_blank');
  }

  handleChange(key) {
    key.preventDefault();
    this.setState({ [key.target.id]: key.target.value });
  }

  handleDeleteProperty(key, id) {
    key.preventDefault();
    const { data } = this.state;

    if (id.length < 1) {
      toast.error('Something wrong occured please try again');
      return;
    }

    if (confirm('CONFIRM TO PROCCESSED )): Your data will lost, if you press OK')) {
      const { session } = verifyLogin();
      const config = { headers: { session, permissionConfig: 'Property Details', feature: 'delete' } };
      this.setState({ result: true });

      axios.post(`${apiList.DELETE_CUSTOMERS_PROPERTY_COMPONENT_API}/${data.id}`, { id }, config)
        .then((response) => {
          toast.success(response.data.message);
          this.setState({ data: { ...response.data.data }, dataLoaded: true });

          setTimeout(() => {
            this.setState({ result: false });
          }, successTimeOut);
        })
        .catch((error) => {
          this.setState({ data: {}, dataLoaded: false });
          toast.error(`${error.response.data.error || error.response.data.message}`);

          setTimeout(() => {
            this.setState({ result: false });
          }, errorTimeOut);
        });
    } else {
      this.setState({ result: false });
    }
  }

  handleEditData(key, element) {
    key.preventDefault();
    this.setState({
      formOpenpc: true,
      newFormpc: false,
      propertyId: element.id,
      componentConfigId: element.componentConfigId,
      componentDimen: element.componentDimen,
      width: element.componentDimen.split('x')[1],
      length: element.componentDimen.split('x')[0],
      floorNumber: element.floorNumber,
    });
  }

  handleSaveAdd(key) {
    key.preventDefault();
    const {
      data, newFormpc, propertyId, componentConfig, floorNumber, componentConfigId, width, length,
    } = this.state;

    const componentDimen = `${length}x${width}`;
    if (data.id.length < 1 || floorNumber.length < 1 || componentConfigId.length < 1
      || componentDimen.length < 1 || floorNumber === '#78' || componentConfigId === '#78') {
      toast.error('Please fill the form fieds first');
      return;
    }

    this.setState({ result: true });
    const { session } = verifyLogin();

    if (!newFormpc) {
      const config = { headers: { session, permissionConfig: 'Property Component', feature: 'edit' } };
      axios.patch(`${apiList.UPDATE_CUSTOMERS_PROPERTY_COMPONENT_API}/${data.id}`, {
        id: propertyId,
        propertyId: data.LoanProperty.id,
        floorNumber,
        componentConfigId,
        componentDimen,
        componentName: componentConfigId ? `${componentConfig.find((element) => element.id === Number(componentConfigId)).componentName} ${componentDimen ? `(${componentDimen})` : '(0 x 0)'}` : '',
      }, config)
        .then((response) => {
          toast.success(response.data.message);
          this.setState({ data: { ...response.data.data }, dataLoaded: true, formOpenpc: false });
          setTimeout(() => {
            this.setState({ result: false });
          }, successTimeOut);
        })
        .catch((error) => {
          toast.error(`${error.response.data.error || error.response.data.message}`);
          setTimeout(() => {
            this.setState({ result: false });
          }, errorTimeOut);
        });
      return;
    }
    const config = { headers: { session, permissionConfig: 'Property Component', feature: 'add' } };
    axios.post(`${apiList.SAVE_CUSTOMERS_PROPERTY_COMPONENT_API}/${data.id}`, {
      propertyId: data.LoanProperty.id,
      floorNumber,
      componentConfigId,
      componentDimen,
      componentName: componentConfigId ? `${componentConfig.find((element) => element.id === Number(componentConfigId)).componentName} ${componentDimen ? `(${componentDimen})` : '(0 x 0)'}` : '',
    }, config)
      .then((response) => {
        this.setState({ data: { ...response.data.data }, dataLoaded: true, formOpenpc: false });

        this.setState({ result: false });
      })
      .catch((error) => {
        toast.error(`${error.response.data.error || error.response.data.message}`);

        this.setState({ result: false });
      });
  }

  getLoanDetails() {
    const { session } = verifyLogin();
    const config = { headers: { session, permissionConfig: 'Loan', feature: 'view' } };
    const detailId = dencrypt(this.props.match.params.detailId);
    axios.get(`${apiList.VEIW_CUSTOMERS_DETAILS_API}/${detailId}`, config)
      .then((response) => {
        const newData = { ...response.data.data };
        this.setState({
          data: newData,
          dataLoaded: true,
        });
        if (newData?.LoanDisbursal.length > 0) {
          const loanAmountDisbursed = JSON.parse(summation(newData.LoanDisbursal, 'disAmount'));
          const loanAmountTObeDisbursed = newData.sanctionedAmount - loanAmountDisbursed;
          const lastDisbarsalDate = moment.max(newData.LoanDisbursal.map((dis) => moment(dis.disDate, 'DD-MM-YYYY HH:mm:ss'))).format('DD-MM-YYYY');
          const lastDisbarsalAmount = newData.LoanDisbursal.find(
            (element) => moment(element.disDate, 'DD-MM-YYYY HH:mm:ss').format('DD-MM-YYYY') === lastDisbarsalDate,
          )?.disAmount;
          this.setState({
            loanAmountDisbursed,
            loanAmountTObeDisbursed,
            lastDisbarsalAmount,
            lastDisbarsalDate,
          });
        }

        if (response.data.data?.LoanProperty) {
          // The plan fetch ends the first-load skeleton.
          this.handleFetchExistingPlan(response.data.data.LoanProperty.id);
        } else {
          this.setState({ initialLoading: false });
        }
        if (response.data.data?.LoanProperty?.PropertyComponent
          && response.data.data.LoanProperty.PropertyComponent.length > 0) {
          this.setState({ showPropertyComponents: true });
        }

        this.setState({ result: false });
      })
      .catch((error) => {
        toast.error(`${error?.response?.data?.error || error?.response?.data?.message || 'Error Occuered'}`);
        this.setState({ result: false, initialLoading: false });
      });
  }

  // Opens the photo picker for the progress report in a new tab.
  openProgressReport = (formatId) => {
    const params = {
      propertyId: this.state.data.LoanProperty.id,
      loanId: dencrypt(this.props.match.params.detailId),
      reportFormatType: formatId,
    };
    const detailId = encrypt(JSON.stringify(params));
    const redirectUrl = `/files/${detailId}`;
    window.open(redirectUrl, '_blank');
    this.setState({ reportFormatListModal: false });
  };

  // Construction-plan items still Submitted / Uploading: they block the
  // progress report. Each links to its activity page, opened on that item.
  getPendingActivities = () => {
    const { constructionPlan, data } = this.state;
    if (!Array.isArray(constructionPlan) || !data?.LoanProperty) return [];
    return groupDataByactivityTypeAndName(constructionPlan).flatMap((group, index) => group.data
      .filter(({ status }) => status === 'Submitted' || status === 'Uploading')
      .map((item) => {
        const floor = item.propertyComponentFloorName;
        const component = item.propertyComponentName;
        const detailId = encrypt(JSON.stringify({
          index,
          planId: item.id,
          propertyId: data.LoanProperty.id,
          isCurrentPlan: true,
          constructionPlanVersion: group.version,
        }));
        return {
          key: item.id,
          title: item.activityConfigName,
          subtitle: [floor, component && component !== floor ? component : null]
            .filter(Boolean).join(' · '),
          status: item.status,
          href: `/view-construction-details/${detailId}`,
        };
      }));
  };

  body = () => (
    <FormLoanProperty
      handleChange={(id) => this.handleChange(id)}
      propertyDescription={this.state.propertyDescription}
      addressLine1={this.state.addressLine1}
      addressLine2={this.state.addressLine2}
      lat={this.state.lat}
      lng={this.state.lng}
    />
  )

  bodypc = () => (
    <FormPropertyComponent
      data={this.state.data}
      floorNameConfig={this.state.floorNameConfig}
      handleChange={(id) => this.handleChange(id)}
      setFloorNum={(event) => this.setState({ floorNumber: event.target.value })}
      setComponentConfigId={(event) => this.setState({ componentConfigId: event.target.value })}
      floorNumber={this.state.floorNumber}
      componentConfigId={this.state.componentConfigId}
      componentConfig={this.state.componentConfig}
      componentDimen={this.state.componentDimen}
      length={this.state.length}
      width={this.state.width}
      lng={this.state.lng}
    />
  )

  loanTaskBody = () => (
    <FormLoanTask
      branchIFSC={this.state.data.branchIFSC}
      subscriberId={this.state.data?.subscriberId}
      loanTaskDetails={this.state.loanTaskDetails}
      setLoanTaskDetails={(loanTaskDetails) => {
        this.setState({ loanTaskDetails });
      }}
    />
  )

  disbursementBody = () => (
    <FormLoanDisbursement
      disbursementAmount={this.state.disbursementAmount}
      disbursementPerc={this.state.disbursementPerc}
      disbursementDate={this.state.disbursementDate}
      totalPercentage={this.state.totalPercentage}
      handleChange={(id) => this.handleChange(id)}
      setDisbursementDate={(disbursementDate) => {
        this.setState({ disbursementDate });
      }}
    />
  )

  customerDetailsBodyForm = () => (
    <FormCustomerDetails
      loanID={this.state.data.id}
      ref={(el) => { this.refFromCustomer = el; }}
      owner={this.state.owner}
      contractor={this.state.contractor}
      projectManager={this.state.projectManager}
      externalValuer={this.state.externalValuer}
      ownerID={this.state.ownerID}
      contractorID={this.state.contractorID}
      projectManagerID={this.state.projectManagerID}
      externalValuerID={this.state.externalValuerID}
      geoTaggPermission={this.state.geoTaggPermission}
      mediaSubmissionNoPlanPermission={this.state.mediaSubmissionNoPlanPermission}
      mediaSubmissionPeriodPermission={this.state.mediaSubmissionPeriodPermission}
      complete={() => {
        this.getLoanDetails();
        this.setState({ formCustomerIDsOpen: false });
      }}
      mapCircleRadius={this.state.mapCircleRadius}
      isMediaSubmissionAllowedWithoutConsPlan={this.state.isMediaSubmissionAllowedWithoutConsPlan}
      gapForNextMediaSubmission={this.state.gapForNextMediaSubmission}
      disbursementSubmissionAllow={this.state.disbursementSubmissionAllow}
    />
  )

  createConstructionPlanBody = () => (
    <FormCreateConstructionPlan
      subscriberId={this.state.data?.subscriberId}
      planName={this.state.planName}
      noOfFloors={this.state.data?.LoanProperty?.noOfFloors}
      loanTypeId={this.state.data?.loanTypeId}
      planID={this.state.planID}
      setPlanID={(planID) => {
        this.setState({ planID });
      }}

    />
  )

  saveCustomerDetails = () => {
    const { session } = verifyLogin();
    const config = { headers: { session, permissionConfig: 'Loan', feature: 'edit' } };
    const params = {};
    const {
      ownerID, contractorID, projectManagerID, externalValuerID,
    } = this.state;
    const { complete } = this.props;
    if (ownerID === -1 && contractorID === -1
      && projectManagerID === -1 && externalValuerID === -1) {
      return;
    }
    if (ownerID) {
      params.ownerID = ownerID;
    }
    if (contractorID) {
      params.contractorID = contractorID;
    }
    if (projectManagerID) {
      params.projectManagerID = projectManagerID;
    }
    if (externalValuerID) {
      params.externalValuerID = externalValuerID;
    }
    axios.post(`${apiList.SAVE_CUSTOMER_ID_DETAILS}`, params, config)
      .then((response) => {
        if (response) {
          complete();
        }
      })
      .catch((error) => {
        toast.error(`${error.response.data.error || error.response.data.message}`);
      });
  };

  updatePropertyDetails(key) {
    key.preventDefault();
    const {
      data, propertyDescription, addressLine1, addressLine2, lat, lng,
    } = this.state;

    const pattern = new RegExp('^-?([1-8]?[1-9]|[1-9]0)\\.{1}\\d{1,6}');
    if (!pattern.test(lat)) {
      toast.error('Invalid latitude');
      return;
    }
    if (!pattern.test(lng)) {
      toast.error('Invalid longitude');
      return;
    }

    if (data.id.length < 1 || addressLine1.length < 1
      || addressLine2.length < 1 || lat.length < 1 || lng.length < 1) {
      toast.error('Please fill the form fieds first');
      return;
    }

    this.setState({ result: true });
    const { session } = verifyLogin();
    const config = { headers: { session, permissionConfig: 'Property Details', feature: 'edit' } };
    axios.patch(`${apiList.UPDATE_CUSTOMERS_PROPERTY_DETAILS}`, {
      id: data.LoanProperty.id,
      loanId: data.id,
      propertyDescription,
      addressLine1,
      addressLine2,
      lat,
      lng,
    }, config)
      .then((response) => {
        toast.success(response.data.message);
        this.setState({ formOpen: false });
        this.setState({ data: { ...response.data.data }, dataLoaded: true, formOpenpc: false });
        this.setState({ result: false });
      })
      .catch((error) => {
        toast.error(`${error.response.data.error || error.response.data.message}`);
        this.setState({ result: false });
      });
  }

  saveLoanTask() {
    const { loanTaskDetails, data } = this.state;
    if (loanTaskDetails.taskTypeId?.length < 1
      || loanTaskDetails.ownerId?.length < 1
      || !loanTaskDetails?.plannedDate || loanTaskDetails?.plannedDate?.length < 1) {
      toast.error('Please Fill all the details');
      return;
    }
    const { session } = verifyLogin();
    const config = { headers: { session, permissionConfig: 'Loan Tasks', feature: loanTaskDetails.id ? 'edit' : 'add' } };
    const params = loanTaskDetails;
    params.loanId = data.id;
    axios.post(`${apiList.SAVE_LOAN_TASK}`, params, config)
      .then((response) => {
        toast.success(response.data.message);
        this.setState({
          loanTaskDetails: {},
        });
        this.setState({ formLoanTaskOpen: false });
        this.taskConfigTableRef.current.getTasks();
        this.setState({ result: false });
      })
      .catch((error) => {
        toast.error(`${error.response.data.error || error.response.data.message}`);
        this.setState({ result: false });
      });
  }

  saveLoanDisbursement() {
    const {
      disbursementAmount, disbursementPerc,
      disbursementDate, data, disbursementId,
    } = this.state;
    console.log('disbursementDate', disbursementDate);
    if (disbursementAmount.length < 1 || !disbursementDate || disbursementDate?.length < 1) {
      toast.error('Please Fill all the details');
      return;
    }
    const { session } = verifyLogin();
    const config = { headers: { session, permissionConfig: 'Disbursement', feature: disbursementId ? 'edit' : 'add' } };
    const params = {
      loanId: data.id,
      disAmountPercentage: disbursementPerc / 100,
      disAmount: disbursementAmount.trim(),
      disDate: disbursementDate,
    };
    if (disbursementId) {
      params.id = disbursementId;
    }
    axios.post(`${apiList.UPDATE_DISBURSEMENT}`, params, config)
      .then((response) => {
        toast.success(response.data.message);
        this.disbumentTableRef.current.getDisbursement();
        this.setState({
          disbursementAmount: '',
          disbursementPerc: '',
          totalPercentage: 0,
          disbursementDate: '',
          disbursementId: null,
          disbursementModalOpen: false,
        });
        this.getLoanDetails();
        this.setState({ result: false });
      })
      .catch((error) => {
        toast.error(`${error.response.data.error || error.response.data.message}`);
        this.setState({ result: false });
      });
  }

  render() {
    const {
      result,
      sectionOne,
      sectionTwo,
      sectionThree,
      sectionFour,
      sectionFive,
      sectionSix,
      sectionSeven,
      sectionNine,

      data,
      constructionPlan,

      dataLoaded,
      constructionPlanLoaded,

      propertyDescription,
      addressLine1,
      addressLine2,
      lat,
      lng,

      formOpen,
      newForm,
      formOpenpc,
      newFormpc,
      showAlert,
      formCustomerIDsOpen,
      formAddPlanIDOpen,

      sectionEight,
      formLoanTaskOpen,
      loanTaskDetails,
      showContructionPlanModuleAlert,
      disbursementId,
      disbursementModalOpen,

      loanPermission,
      customerPermission,
      disbursementPermission,
      propDetailsPermission,
      propComponentsPermission,
      constructionPlanPermission,
      loanTaskPermission,
      disRequestPermission,
      loanAmountDisbursed,
      loanAmountTObeDisbursed,
      lastDisbarsalDate,
      lastDisbarsalAmount,
      showPropertyComponents,
      constructionModuleplanName,
      constructionPlanVersion,
      isCurrentPlan,
      geoTaggPermission,
      mediaSubmissionNoPlanPermission,
      mediaSubmissionPeriodPermission,
      reportFormatListModal,
      oldPlansOpen,
      initialLoading,
    } = this.state;
    // Earlier versions exist once the plan has been reset.
    const showOldPlans = constructionPlanVersion > 1 && constructionPlanPermission.view
      && Boolean(data?.LoanProperty);

    verifyLogin();
    return (
      <div className='ds-page'>

        {result === true ? <Loading MainProps={this.props} /> : null}

        <ToastContainer />

        {showOldPlans ? (
          <OldPlansPanel
            open={Boolean(oldPlansOpen)}
            onClose={() => this.setState({ oldPlansOpen: false })}
            propertyId={data.LoanProperty.id}
            currentVersion={constructionPlanVersion}
            currentPlan={constructionPlan}
            constructionPlanPermission={constructionPlanPermission}
          />
        ) : null}

        <ReportFormatPanel
          open={reportFormatListModal}
          type={1}
          title='Download progress report'
          subtitle='Choose a report format. Next, you will pick up to 6 photos for the report.'
          actionLabel='Choose photos'
          onClose={() => this.setState({ reportFormatListModal: false })}
          onGenerate={(id) => this.openProgressReport(id)}
          blockers={{
            title: 'Take action on submitted activities',
            message: 'Verify or reject the activities below before you can download the progress report.',
            items: this.getPendingActivities(),
          }}
        />

        <CustomAlert
          open={showAlert}
          negtiveBtn='Ok'
          title='No Property!'
          content='Please link property to Loan to add property components'
          handleClose={() => {
            this.setState({ showAlert: false });
          }}
        />

        <SidePanel
          open={formOpen}
          setOpen={(value) => this.setState({ formOpen: value })}
          newForm={newForm}
          body={this.body()}
          handleSaveData={(key) => this.updatePropertyDetails(key)}
          title='Update Property Details'
        />

        <SidePanel
          open={formOpenpc}
          setOpen={(value) => this.setState({ formOpenpc: value })}
          newForm={newFormpc}
          body={this.bodypc()}
          handleSaveData={(key) => this.handleSaveAdd(key)}
          title={newFormpc ? 'Add Property Component' : 'Update Property Component'}
        />

        <SidePanel
          open={formLoanTaskOpen}
          setOpen={(value) => this.setState({ formLoanTaskOpen: value })}
          newForm={!loanTaskDetails.id}
          body={this.loanTaskBody()}
          handleSaveData={() => this.saveLoanTask()}
          title={!loanTaskDetails.id ? 'Add Task' : 'Update Task'}
        />

        <SidePanel
          open={disbursementModalOpen}
          setOpen={(value) => this.setState({ disbursementModalOpen: value })}
          newForm={!disbursementId}
          body={this.disbursementBody()}
          handleSaveData={() => this.saveLoanDisbursement()}
          title={!disbursementId ? 'Add Disbursement' : 'Update Disbursement'}
        />

        <SidePanel
          open={formCustomerIDsOpen}
          setOpen={(value) => this.setState({ formCustomerIDsOpen: value })}
          newForm={false}
          body={this.customerDetailsBodyForm()}
          handleSaveData={() => this.refFromCustomer.saveCustomerDetails()}
          title='Update Customer Details'
        />

        <CustomAlert
          open={showContructionPlanModuleAlert}
          handleYes={() => {
            this.setState({
              formAddPlanIDOpen: true,
              planID: -1,
              planName: '',
              showContructionPlanModuleAlert: false,
            });
          }}
          title='Do you wanna proceed?'
          content='Are you sure you want to Reset plan? It will delete all the data and progress summited for this loan.'
          handleClose={() => {
            this.setState({ showContructionPlanModuleAlert: false });
          }}
        />

        <CustomModal
          width='xs'
          open={formAddPlanIDOpen}
          setOpen={(value) => this.setState({ formAddPlanIDOpen: value, planID: -1, planName: '' })}
          newForm={false}
          body={this.createConstructionPlanBody()}
          handleSaveData={(key) => {
            this.handleCreateConstructionPlanButton(key);
            this.setState({ formAddPlanIDOpen: false });
          }}
          title='Choose Construction Plan Module'
        />

        <Navbar MainProps={this.props} />

        <PageContainer width='narrow' stack className={initialLoading ? '' : 'ds-loaded'}>
          {initialLoading ? <DetailPageSkeleton sections={['fields', 'fields', 'fields', 'table']} /> : (
            <>
              {/* Stays at the top while scrolling: which loan this is. */}
              {dataLoaded && data ? (
                <div className='ds-banner'>
                  <h1 className='ds-banner-item main' title='Loan number'>
                    <span className='ds-banner-icon'><ReceiptOutlinedIcon /></span>
                    {data.loanNumber || 'N/A'}
                  </h1>
                  <span className='ds-banner-item' title='Customer'>
                    <span className='ds-banner-icon'><PersonOutlineRoundedIcon /></span>
                    {data.custName || 'N/A'}
                  </span>
                  <span className='ds-banner-item' title='Mobile'>
                    <span className='ds-banner-icon'><PhoneOutlinedIcon /></span>
                    {data.custMobile ? <a href={`tel:${data.custMobile}`}>{data.custMobile}</a> : 'N/A'}
                  </span>
                </div>
              ) : null}

              <DetailSection
                title='Customer'
                icon={PersonOutlineRoundedIcon}
                open={sectionOne}
                onToggle={(key) => { this.handleCollapse(key, 'sectionOne'); }}
                actions={sectionOne && (geoTaggPermission.edit
              || mediaSubmissionNoPlanPermission.edit
              || mediaSubmissionPeriodPermission.edit) ? (
                <SectionButton
                  icon={EditOutlinedIcon}
                  onClick={() => {
                    this.setState({
                      formCustomerIDsOpen: true,
                      owner: data.Owner ? `${data.Owner?.firstName} ${data.Owner?.lastName}` : '',
                      contractor: data.Contractor ? `${data.Contractor?.firstName} ${data.Contractor?.lastName}` : '',
                      projectManager: data.ProjectManager ? `${data.ProjectManager?.firstName} ${data.ProjectManager?.lastName}` : '',
                      externalValuer: data.ExternalValuer ? `${data.ExternalValuer?.firstName} ${data.ExternalValuer?.lastName}` : '',
                      ownerID: data.Owner ? data.Owner?.id : -1,
                      contractorID: data.Contractor ? data.Contractor?.id : -1,
                      projectManagerID: data.ProjectManager ? data.ProjectManager?.id : -1,
                      externalValuerID: data.ExternalValuer ? data.ExternalValuer?.id : -1,
                      mapCircleRadius: data.mapCircleRadius,
                      isMediaSubmissionAllowedWithoutConsPlan:
                        data.isMediaSubmissionAllowedWithoutConsPlan,
                      gapForNextMediaSubmission: data.gapForNextMediaSubmission,
                      disbursementSubmissionAllow: data.disbursementSubmissionAllow,
                    });
                  }}
                >
                  Edit
                </SectionButton>
                  ) : null}
              >
                {customerPermission.view && dataLoaded && data ? (
                  <FieldGrid>
                    <Field label='Name'>{`${data.custName || 'N/A'}`}</Field>
                    <Field label='Mobile'>{`${data.custMobile || 'N/A'}`}</Field>
                    <Field label='Email'>{`${data.custEmail || 'N/A'}`}</Field>
                    {geoTaggPermission.view ? (
                      <Field label='Geo Tagging'>{data?.mapCircleRadius === '-1' ? 'Disabled' : 'Enabled'}</Field>
                    ) : null}
                    {mediaSubmissionNoPlanPermission.view ? (
                      <Field label='Allow Progress w/o Plan'>{data.isMediaSubmissionAllowedWithoutConsPlan === 'true' ? 'True' : 'False'}</Field>
                    ) : null}
                    {mediaSubmissionPeriodPermission.view ? (
                      <Field label='Media Submission Period'>{`${data.gapForNextMediaSubmission || 0} days`}</Field>
                    ) : null}
                    <Field label='Eligible for Request'>{data.disbursementSubmissionAllow === 'false' ? 'No' : 'Yes'}</Field>
                    <Field label='Contractor'>
                      {`${data.Contractor ? (`${data.Contractor?.firstName} ${data.Contractor?.lastName}`) : 'N/A'}`}
                    </Field>
                    <Field label='Project Manager'>
                      {`${data.ProjectManager ? (`${data.ProjectManager?.firstName} ${data.ProjectManager?.lastName}`) : 'N/A'}`}
                    </Field>
                    <Field label='External Valuer'>
                      {`${data.ExternalValuer ? (`${data.ExternalValuer?.firstName} ${data.ExternalValuer?.lastName}`) : 'N/A'}`}
                    </Field>
                    <Field label='Created At'>{`${shortDate(data.createdAt) || 'N/A'}`}</Field>
                  </FieldGrid>
                ) : null}
              </DetailSection>

              <DetailSection
                title='Loan'
                icon={AccountBalanceOutlinedIcon}
                open={sectionTwo}
                onToggle={(key) => { this.handleCollapse(key, 'sectionTwo'); }}
              >
                {loanPermission.view && dataLoaded && data ? (
                  <FieldGrid>
                    <Field label='Loan Number'>{`${data.loanNumber || 'N/A'}`}</Field>
                    <Field label='Loan Type'>{data?.LoanType?.loanType}</Field>
                    <Field label='Branch Name'>{`${data?.AccessLevelConfig?.branchName || 'N/A'}`}</Field>
                    <Field label='Property Value'>{`${addCommas(data.propertyValue) || 'N/A'}`}</Field>
                    <Field label='Construction Value'>{`${addCommas(data.constructionValue) || 'N/A'}`}</Field>
                    <Field label='Land Value'>{`${addCommas(data.landValue) || 'N/A'}`}</Field>
                    <Field label='LTV'>{data.ltv ? `${data.ltv}%` : 'N/A'}</Field>
                    <Field label='Sanctioned Date'>{`${shortDate(data.sanctionedDate) || 'N/A'}`}</Field>
                    <Field label='Sanctioned Amount'>{`${addCommas(data.sanctionedAmount) || 'N/A'}`}</Field>
                    <Field label='Loan amount disbursed'>
                      {`${loanAmountDisbursed ? addCommas(loanAmountDisbursed) : 'N/A'}`}
                    </Field>
                    <Field label='Loan amount to be disbursed'>
                      {`${loanAmountTObeDisbursed ? addCommas(loanAmountTObeDisbursed) : 'N/A'}`}
                    </Field>
                    <Field label='Last disbursal date'>{lastDisbarsalDate || '-'}</Field>
                    <Field label='Last disbursal amount'>
                      {`${lastDisbarsalAmount ? addCommas(lastDisbarsalAmount) : 'N/A'}`}
                    </Field>
                  </FieldGrid>
                ) : null}
              </DetailSection>

              <DetailSection
                title='Property'
                icon={HomeWorkOutlinedIcon}
                open={sectionFour}
                onToggle={(key) => { this.handleCollapse(key, 'sectionFour'); }}
                actions={data.LoanProperty && propDetailsPermission.edit && sectionFour ? (
                  <SectionButton
                    icon={EditOutlinedIcon}
                    onClick={() => {
                      this.setState({
                        formOpen: true,
                        propertyDescription: data?.LoanProperty?.propertyDescription || '',
                        addressLine2: data?.LoanProperty?.addressLine2 || '',
                        addressLine1: data?.LoanProperty?.addressLine1 || '',
                        lat: data?.LoanProperty?.lat || '',
                        lng: data?.LoanProperty?.lng || '',
                      });
                    }}
                  >
                    Edit
                  </SectionButton>
                ) : null}
              >
                {propDetailsPermission.view && dataLoaded && data.LoanProperty ? (
                  <FieldGrid>
                    <Field label='Property Details'>{`${data.LoanProperty.propertyDescription || propertyDescription || 'N/A'}`}</Field>
                    <Field label='Address Line 1'>{`${data.LoanProperty.addressLine1 || addressLine1 || 'N/A'}`}</Field>
                    <Field label='Address Line 2'>{`${data.LoanProperty.addressLine2 || addressLine2 || 'N/A'}`}</Field>
                    <Field label='Pincode'>{`${data.LoanProperty.pincode || 'N/A'}`}</Field>
                    <Field label='City'>{`${data.LoanProperty.cityTown || 'N/A'}`}</Field>
                    <Field label='District'>{`${data.LoanProperty.district || 'N/A'}`}</Field>
                    <Field label='State'>{`${data.LoanProperty.state || 'N/A'}`}</Field>
                    {SHOW_ADD_PROPERTY_COMPONENTS && (!data?.LoanProperty?.PropertyComponent
                  || data.LoanProperty.PropertyComponent.length < 1)
                  && !showPropertyComponents ? (
                    <Field label='Property Components'>
                      <button
                        type='button'
                        className='ds-link'
                        onClick={() => { this.setState({ showPropertyComponents: true }); }}
                      >
                        Click here to add
                      </button>
                    </Field>
                      ) : null}
                    <Field label='Basement'>{data.LoanProperty.basement === 'true' ? 'Yes' : 'No'}</Field>
                    <Field label='Structure Type'>
                      {`${data.LoanProperty.structureType
                        ? (data.LoanProperty.structureType === '1' ? 'RCC Frame' : 'Load Bearing') : 'N/A'}`}
                    </Field>
                    <Field label='Land Area(sqft)'>{`${data.LoanProperty.landArea || 'N/A'}`}</Field>
                    <Field label='No of Floor'>{`${data.LoanProperty.noOfFloors || 'N/A'}`}</Field>
                    <Field label='BUA(sqft)'>{`${data.LoanProperty.builtUpArea || 'N/A'}`}</Field>
                    <Field label='Latitude'>{`${data.LoanProperty.lat || lat || 'N/A'}`}</Field>
                    <Field label='Longitude'>{`${data.LoanProperty.lng || lng || 'N/A'}`}</Field>
                    {(data.LoanProperty.lng || lng) && (data.LoanProperty.lat || lat) ? (
                      <Field label='Google Map Link'>
                        <button
                          type='button'
                          className='ds-link'
                          onClick={() => {
                            const longitude = data.LoanProperty.lng || lng;
                            const latitude = data.LoanProperty.lat || lat;
                            window.open(`https://www.google.com/maps/place/${latitude},${longitude}`, '_blank');
                          }}
                        >
                          Open Location in Google Map
                        </button>
                      </Field>
                    ) : null}
                  </FieldGrid>
                ) : null}
              </DetailSection>

              {showPropertyComponents ? (
                <DetailSection
                  title='Property Components'
                  icon={ViewQuiltOutlinedIcon}
                  open={sectionFive}
                  onToggle={(key) => { this.handleCollapse(key, 'sectionFive'); }}
                  actions={sectionFive && propComponentsPermission.add ? (
                    <SectionButton
                      icon={AddRoundedIcon}
                      onClick={(key) => (data.LoanProperty
                        ? this.handleShowAddForm(key) : this.setState({ showAlert: true }))}
                    >
                      Add Component
                    </SectionButton>
                  ) : null}
                >
                  {propComponentsPermission.view ? (
                    <PropertyComponentDetailsTable
                      bare
                      propComponentsPermission={propComponentsPermission}
                      handleShowAddForm={(key) => { this.handleShowAddForm(key); }}
                      data={data?.LoanProperty?.PropertyComponent
                        ? data.LoanProperty.PropertyComponent : []}
                      handleEditData={(key, element) => { this.handleEditData(key, element); }}
                      handleDeleteProperty={(key, i) => { this.handleDeleteProperty(key, i); }}
                    />
                  ) : null}
                </DetailSection>
              ) : null}

              <DetailSection
                title='Construction Plan'
                icon={AssignmentOutlinedIcon}
                open={sectionSix}
                onToggle={(key) => { this.handleCollapse(key, 'sectionSix'); }}
              >
                {constructionPlanPermission.view ? (
                  <>
                    {constructionPlanVersion > 0 ? (
                      <FieldGrid>
                        <Field label='Construction Plan Name'>{constructionModuleplanName}</Field>
                        <Field label='Construction Plan Version'>{constructionPlanVersion}</Field>
                      </FieldGrid>
                    ) : null}
                    {data && data.LoanProperty ? (
                      <ConstructionPlanTable
                        bare
                        isCurrentPlan
                        propertyId={data.LoanProperty.id}
                        constructionPlanPermission={constructionPlanPermission}
                        data={constructionPlanLoaded === true
                      && constructionPlan && constructionPlan.length > 0 ? constructionPlan : []}
                      />
                    ) : null}
                  </>
                ) : null}
                {(isCurrentPlan && constructionPlanPermission.add) || showOldPlans ? (
                  <SectionFooter>
                    {showOldPlans ? (
                      <SectionButton
                        quiet
                        icon={HistoryRoundedIcon}
                        onClick={() => this.setState({ oldPlansOpen: true })}
                      >
                        {`Old plans (${constructionPlanVersion - 1})`}
                      </SectionButton>
                    ) : null}
                    {isCurrentPlan && constructionPlanPermission.add ? (
                      <>
                        <SectionButton
                          icon={constructionPlan.length > 0
                            ? ReplayRoundedIcon : PlaylistAddRoundedIcon}
                          onClick={() => {
                            if (constructionPlan.length > 0) {
                              this.setState({ showContructionPlanModuleAlert: true });
                            } else {
                              this.setState({
                                formAddPlanIDOpen: true,
                                planID: -1,
                                planName: '',
                              });
                            }
                          }}
                        >
                          {constructionPlan.length > 0 ? 'Reset Plan' : 'Generate Plan'}
                        </SectionButton>
                        {constructionPlan.length > 0 && !constructionPlan.every(({ status }) => status === 'Yet to start') ? (
                          <SectionButton
                            icon={GetAppRoundedIcon}
                            onClick={() => this.setState({ reportFormatListModal: true })}
                          >
                            Download Report
                          </SectionButton>
                        ) : null}
                      </>
                    ) : null}
                  </SectionFooter>
                ) : null}
              </DetailSection>

              {SHOW_UNCATEGORIZED_MEDIA ? (
                <DetailSection
                  title='Construction Progress (Photos & Videos)'
                  icon={PhotoLibraryOutlinedIcon}
                  open={sectionNine}
                  onToggle={(key) => { this.handleCollapse(key, 'sectionNine'); }}
                >
                  {data?.LoanProperty && constructionPlanPermission.view ? (
                    <UncategorizedMediaTable
                      bare
                      loanId={dencrypt(this.props.match.params.detailId)}
                      loanNumber={data.loanNumber}
                      propertyDescription={propertyDescription}
                      address={`${data.LoanProperty.addressLine1} ${data.LoanProperty.addressLine2} ${data.LoanProperty.cityTown},  ${data.LoanProperty.district}`}
                      lat={data.LoanProperty.lat}
                      lng={data.LoanProperty.lng}
                    />
                  ) : null}
                </DetailSection>
              ) : null}

              <DetailSection
                title='Task'
                icon={PlaylistAddCheckOutlinedIcon}
                open={sectionEight}
                onToggle={(key) => { this.handleCollapse(key, 'sectionEight'); }}
                actions={sectionEight && loanTaskPermission.add ? (
                  <SectionButton
                    icon={AddRoundedIcon}
                    onClick={() => {
                      this.setState({
                        loanTaskDetails: { loanId: data.id },
                        formLoanTaskOpen: true,
                      });
                    }}
                  >
                    Add Task
                  </SectionButton>
                ) : null}
              >
                {loanTaskPermission.view ? (
                  <TaskTable
                    bare
                    ref={this.taskConfigTableRef}
                    loanId={dencrypt(this.props.match.params.detailId)}
                    loanTaskPermission={loanTaskPermission}
                    handleEditData={(key, element) => {
                      this.setState({
                        loanTaskDetails: element,
                        formLoanTaskOpen: true,
                      });
                    }}
                  />
                ) : null}
              </DetailSection>

              <DetailSection
                title='Disbursal Requests'
                icon={MoveToInboxOutlinedIcon}
                open={sectionSeven}
                onToggle={(key) => { this.handleCollapse(key, 'sectionSeven'); }}
              >
                {disRequestPermission.view ? (
                  <DisbursalTable
                    bare
                    subscriberName={data.Subscribers?.subscriberName}
                    branchIFSC={data.branchIFSC}
                    loanAmountDisbursed={loanAmountDisbursed}
                    loanId={dencrypt(this.props.match.params.detailId)}
                    disRequestPermission={disRequestPermission}
                  />
                ) : null}
              </DetailSection>

              <DetailSection
                title='Disbursements'
                icon={AccountBalanceWalletOutlinedIcon}
                open={sectionThree}
                onToggle={(key) => { this.handleCollapse(key, 'sectionThree'); }}
                actions={sectionThree && disbursementPermission.add ? (
                  <SectionButton
                    icon={AddRoundedIcon}
                    onClick={() => {
                      this.setState({
                        disbursementModalOpen: true,
                        disbursementId: null,
                        disbursementDate: null,
                        disbursementAmount: '',
                        disbursementPerc: '',
                        totalPercentage: dataLoaded && data && data.LoanDisbursal.length > 0
                          ? summation(data.LoanDisbursal, 'disAmountPercentage').toFixed(2) * 100 : 0,
                      });
                    }}
                  >
                    Add Disbursement
                  </SectionButton>
                ) : null}
              >
                {disbursementPermission.view ? (
                  <DisbursementTable
                    bare
                    ref={this.disbumentTableRef}
                    data={dataLoaded && data
                  && data.LoanDisbursal?.length > 0 ? data.LoanDisbursal : []}
                    loanId={dencrypt(this.props.match.params.detailId)}
                    disbursementPermission={disbursementPermission}
                    deleteDisbursement={() => {
                      this.getLoanDetails();
                    }}
                    handleviewDetails={() => { }}
                    handleEditData={(key, element) => {
                      this.setState({
                        disbursementModalOpen: true,
                        disbursementId: element.id,
                        disbursementDate: element.disDate,
                        disbursementAmount: element.disAmount,
                        disbursementPerc: shortData(element.disAmountPercentage) * 100,
                        totalPercentage: dataLoaded && data && data.LoanDisbursal.length > 0
                          ? (summation(data.LoanDisbursal, 'disAmountPercentage').toFixed(2) - element.disAmountPercentage) * 100 : 0,
                      });
                    }}
                  />
                ) : null}
              </DetailSection>

            </>
          )}
        </PageContainer>
      </div>
    );
  }
}

export default LoanDetails;
